export default __webpack_public_path__ + "scripts/resources/assignments/en/kinetics/k1/species.json";